import React from 'react';
import PropTypes from 'prop-types';

import CertifiedSellerBadge from '../../../component/icons/CertifiedSellerBadge';
import UserPreview from '../../../component/userPreview/UserPreview';

import './ReviewReply.css';
import {reviewDateLabel} from '../../../util/util';

function getReviewReply(review) {
    if (!review.reviewReply || review.reviewReply.deletedAt) {
        return null;
    }
    return review.reviewReply;
}

export default function ReviewReply({ review, seller }) {
    const reply = getReviewReply(review);

    if (!reply) {
        return null;
    }

    const replySeller = review.seller || seller;
    const replySellerUser = replySeller.user || seller.user;

    return (
        <div className="ReviewReply">
            <span className="ReviewReply-image">
                <UserPreview user={replySellerUser} />
            </span>
            <div className="ReviewReply-body">
                <div className="ReviewReply-header">
                    <span className="ReviewReply-nickname font-nhaasgrotesk">
                        {replySellerUser.nickname}
                    </span>
                    {replySeller.is_certified && (
                        <CertifiedSellerBadge className="ReviewReply-badge" />
                    )}
                    {reply.createdAt && (
                        <>
                            <span className="ReviewReply-separator" aria-hidden="true">
                                ·
                            </span>
                            <time className="ReviewReply-date" dateTime={reply.createdAt}>
                                {reviewDateLabel(reply.createdAt)}
                            </time>
                        </>
                    )}
                </div>
                <p className="ReviewReply-text">
                    {reply.text}
                </p>
            </div>
        </div>
    );
}
ReviewReply.propTypes = {
    review: PropTypes.shape({
        reviewReply: PropTypes.shape({
            text: PropTypes.string,
            createdAt: PropTypes.string,
            deletedAt: PropTypes.string
        }),
        seller: PropTypes.shape({
            is_certified: PropTypes.bool,
            user: PropTypes.shape({
                nickname: PropTypes.string,
                resizedSmallImage: PropTypes.string
            })
        })
    }).isRequired,
    seller: PropTypes.shape({
        is_certified: PropTypes.bool,
        user: PropTypes.shape({
            nickname: PropTypes.string,
            resizedSmallImage: PropTypes.string
        })
    }).isRequired,
};
